/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useMemo} from "react";
import {useFetchServiceModel} from "../../../Hooks/ServiceHooks";
import {service as SurveyService} from "../../../Services/SurveyService";
import {
	useSurveyQuestions,
} from "../../../../../monitoring/src/Hooks/SharedSurveyHooks";
import {SurveyAnswerFieldViewer} from "./SurveyAnswerFieldViewer";
import {partitionSurveyAnswerDelta, resolveQuestionForAnswer} from "../../../Utils/surveyAnswerUtils";

export function SurveyAnswersFieldViewer(props) {

	const {
		FieldCustomData:customData,
		Event: contextNodeActivity = {}
	} = props;
	const {
		Activity: activity = null,
	} = contextNodeActivity;
	const activityData = activity?.data ?? {};
	const {
		newData = [],
		oldData = [],
		surveyId,
	} = activityData;

	const survey = useFetchServiceModel(SurveyService, surveyId);
	// SB-3022: resolve each delta answer to its question by `code`. The surveyQuestionId fallback is
	// only for legacy activity records recorded before SurveyAnswer.code existed (their delta answers
	// carry no code); current deltas always do.
	const questionsByCode = useSurveyQuestions(survey, 'code');
	const questionsById = useSurveyQuestions(survey);


	if(!survey) {
		return 'Loading...';
	}

	const resolveQuestion = (answer) => resolveQuestionForAnswer(answer, questionsByCode, questionsById);

	// Answers the save cleared are surfaced as removals (prior value + cleared flag) so a
	// clear-only save doesn't render as "No changes." or as a bare empty value. That covers
	// both delta shapes: in oldData but absent from newData, and present in newData with its
	// value columns blanked (e.g. a text input cleared to "").
	const {changed: changedAnswers, removed: removedAnswers} = partitionSurveyAnswerDelta(oldData, newData);
	const hasChanges = changedAnswers.length + removedAnswers.length > 0;

	return <div className="sb-activity-feed-delta-value-display">
		<div className="sb-activity-feed-delta-value-display-new-value">
			{
				!hasChanges
					? <span className="sb-activity-feed-delta-value-display-new-value-empty">No changes.</span>
					: null
			}
			{changedAnswers.map((answer, index) => (
				<SurveyAnswerFieldViewer
					key={`new-${index}`}
					answer={answer}
					question={resolveQuestion(answer)}
				/>
			))}
			{removedAnswers.map((answer, index) => (
				<SurveyAnswerFieldViewer
					key={`removed-${index}`}
					answer={answer}
					question={resolveQuestion(answer)}
					removed={true}
				/>
			))}
		</div>
	</div>;
}
